import { Component, OnDestroy, OnInit } from '@angular/core';
import { Logger } from 'src/services/core/logger/logger.service';
import { SessionStorageTimeoutService } from 'src/services/core/session-storage-timeout/session-storage-timeout.service';

const log = new Logger('App');
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Smart-menu-customer';

  constructor(private sessionStorageTimeout: SessionStorageTimeoutService) {}

  ngOnInit(): void {
    this.sessionStorageTimeout.start();
  }

  ngOnDestroy(): void {
    this.sessionStorageTimeout.stop();
    if (localStorage.getItem('hasChosenOption') !== null) {
      log.debug('Exiting app!');
      localStorage.removeItem('hasChosenOption');
    }
  }
}
